export default function useGetListenToTranslationSupportedLanguages() {
  /**
   * TODO: implement this hook once the supported languages are
   * available through Vocalizer. (LESS-4892).
   */
  return [
    "es", // Spanish (Spain)
    "es-MX", // Spanish (Mexico)
    "fr", // French
    "de", // German
    "it", // Italian
    "ja", // Japanese
    "pt", // Portuguese (Brazil)
    "pt-PT", // Portuguese (Portugal)
    "zh", // Chinese
    "ar", // Arabic
    "cs", // Czech
    "nl", // Dutch
    "el", // Greek
    "fa", // Farsi
    "id", // Indonesian
    "hi", // Hindi
    "lv", // Latvian
    "no", // Norwegian
    "pl", // Polish
    "ro", // Romanian
    "ru", // Russian
    "sk", // Slovak
    "sr", // Serbian
    "sv", // Swedish
    "sw", // Swahili
    "tr", // Turkish
    "uk", // Ukrainian
  ];
}
